import { fetchExperienceDates } from 'actions/ExperienceActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import type { FetchDateParams } from 'lib/experiences/experienceUtils'
import { getExperienceDatesKey, isFetchDatesParamsValid } from 'lib/experiences/experienceUtils'
import { useEffect } from 'react'

function useExperienceAvailableDates(
  experience: App.ExperienceOffer,
  params: FetchDateParams,
): [Array<App.ExperienceAvailabilityDate>, boolean, any] {
  const { redemptionLocationId } = params

  const dispatch = useAppDispatch()
  const experienceDates = useAppSelector(state => state.experience.experienceDates[experience.id])

  const key = getExperienceDatesKey(experience.id, {
    pickupPointId: experience.pickupOptional ? undefined : params.pickupPointId,
    redemptionLocationId,
    ticketModesMap: params.ticketModesMap,
  })
  useEffect(() => {
    if (isFetchDatesParamsValid(experience, params)) {
      dispatch(fetchExperienceDates(experience.id, params))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])

  return [
    experienceDates?.[key]?.dates ?? EmptyArray,
    !!experienceDates?.[key]?.fetching,
    experienceDates?.[key]?.error,
  ]
}

export default useExperienceAvailableDates
